/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as WhtRouteImport } from './routes/wht';
import { Route as VatRouteImport } from './routes/vat';
import { Route as TaxreconRouteImport } from './routes/taxrecon';
import { Route as TaxadjRouteImport } from './routes/taxadj';
import { Route as SuppliersRouteImport } from './routes/suppliers';
import { Route as ReportsRouteImport } from './routes/reports';
import { Route as ReconRouteImport } from './routes/recon';
import { Route as ReclassRouteImport } from './routes/reclass';
import { Route as ProptaxRouteImport } from './routes/proptax';
import { Route as PrepaidRouteImport } from './routes/prepaid';
import { Route as PpemoveRouteImport } from './routes/ppemove';
import { Route as PettycashRouteImport } from './routes/pettycash';
import { Route as PcloseRouteImport } from './routes/pclose';
import { Route as PayreqRouteImport } from './routes/payreq';
import { Route as OpcontractRouteImport } from './routes/opcontract';
import { Route as MasterRouteImport } from './routes/master';
import { Route as LvaRouteImport } from './routes/lva';
import { Route as LoginRouteImport } from './routes/login';
import { Route as LedgerRouteImport } from './routes/ledger';
import { Route as LeaseRouteImport } from './routes/lease';
import { Route as JournalRouteImport } from './routes/journal';
import { Route as GlschedRouteImport } from './routes/glsched';
import { Route as FxrevalRouteImport } from './routes/fxreval';
import { Route as FraudRouteImport } from './routes/fraud';
import { Route as FixedassetRouteImport } from './routes/fixedasset';
import { Route as EmpbenRouteImport } from './routes/empben';
import { Route as DocIngestRouteImport } from './routes/doc-ingest';
import { Route as DashboardRouteImport } from './routes/dashboard';
import { Route as ConsolRouteImport } from './routes/consol';
import { Route as CoaRouteImport } from './routes/coa';
import { Route as CipRouteImport } from './routes/cip';
import { Route as CfforecastRouteImport } from './routes/cfforecast';
import { Route as AssetCategoriesRouteImport } from './routes/asset-categories';
import { Route as ArRouteImport } from './routes/ar';
import { Route as ApRouteImport } from './routes/ap';
import { Route as AdvanceRouteImport } from './routes/advance';
import { Route as AccrualRouteImport } from './routes/accrual';
import { Route as IndexRouteImport } from './routes/index';
import { Route as SettingsUsersRouteImport } from './routes/settings.users';
import { Route as SettingsScanIntakeRouteImport } from './routes/settings.scan-intake';
import { Route as SettingsRolesRouteImport } from './routes/settings.roles';
import { Route as SettingsLineIntakeRouteImport } from './routes/settings.line-intake';
import { Route as SettingsEmailIntakeRouteImport } from './routes/settings.email-intake';
import { Route as SettingsCoaRouteImport } from './routes/settings.coa';
import { Route as SettingsAuditRouteImport } from './routes/settings.audit';
import { Route as SettingsApprovalMatrixRouteImport } from './routes/settings.approval-matrix';
import { Route as SettingsAccountMappingRouteImport } from './routes/settings.account-mapping';
import { Route as LvaCodeRouteImport } from './routes/lva.$code';
import { Route as DocIngestIdRouteImport } from './routes/doc-ingest.$id';
import { Route as AuthCallbackRouteImport } from './routes/auth.callback';
import { Route as ArVoidsRouteImport } from './routes/ar.voids';
import { Route as ArReceiptsRouteImport } from './routes/ar.receipts';
import { Route as ArPdcRouteImport } from './routes/ar.pdc';
import { Route as ArDsoRouteImport } from './routes/ar.dso';
import { Route as ArCreditNotesRouteImport } from './routes/ar.credit-notes';
import { Route as ArBillingNotesRouteImport } from './routes/ar.billing-notes';
import { Route as ArAgingRouteImport } from './routes/ar.aging';
import { Route as ArAdvancesRouteImport } from './routes/ar.advances';
import { Route as AdvanceIdRouteImport } from './routes/advance.$id';
import { Route as LvaCountRoundIdRouteImport } from './routes/lva.count.$roundId';
import { Route as ArStatementCustomerIdRouteImport } from './routes/ar.statement.$customerId';
import { Route as ArInvoicesIdRouteImport } from './routes/ar.invoices.$id';
import { Route as ApVendorVendorIdRouteImport } from './routes/ap.vendor.$vendorId';

const WhtRoute = WhtRouteImport.update({
  id: '/wht',
  path: '/wht',
  getParentRoute: () => rootRouteImport,
} as any);
const VatRoute = VatRouteImport.update({
  id: '/vat',
  path: '/vat',
  getParentRoute: () => rootRouteImport,
} as any);
const TaxreconRoute = TaxreconRouteImport.update({
  id: '/taxrecon',
  path: '/taxrecon',
  getParentRoute: () => rootRouteImport,
} as any);
const TaxadjRoute = TaxadjRouteImport.update({
  id: '/taxadj',
  path: '/taxadj',
  getParentRoute: () => rootRouteImport,
} as any);
const SuppliersRoute = SuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => rootRouteImport,
} as any);
const ReportsRoute = ReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRouteImport,
} as any);
const ReconRoute = ReconRouteImport.update({
  id: '/recon',
  path: '/recon',
  getParentRoute: () => rootRouteImport,
} as any);
const ReclassRoute = ReclassRouteImport.update({
  id: '/reclass',
  path: '/reclass',
  getParentRoute: () => rootRouteImport,
} as any);
const ProptaxRoute = ProptaxRouteImport.update({
  id: '/proptax',
  path: '/proptax',
  getParentRoute: () => rootRouteImport,
} as any);
const PrepaidRoute = PrepaidRouteImport.update({
  id: '/prepaid',
  path: '/prepaid',
  getParentRoute: () => rootRouteImport,
} as any);
const PpemoveRoute = PpemoveRouteImport.update({
  id: '/ppemove',
  path: '/ppemove',
  getParentRoute: () => rootRouteImport,
} as any);
const PettycashRoute = PettycashRouteImport.update({
  id: '/pettycash',
  path: '/pettycash',
  getParentRoute: () => rootRouteImport,
} as any);
const PcloseRoute = PcloseRouteImport.update({
  id: '/pclose',
  path: '/pclose',
  getParentRoute: () => rootRouteImport,
} as any);
const PayreqRoute = PayreqRouteImport.update({
  id: '/payreq',
  path: '/payreq',
  getParentRoute: () => rootRouteImport,
} as any);
const OpcontractRoute = OpcontractRouteImport.update({
  id: '/opcontract',
  path: '/opcontract',
  getParentRoute: () => rootRouteImport,
} as any);
const MasterRoute = MasterRouteImport.update({
  id: '/master',
  path: '/master',
  getParentRoute: () => rootRouteImport,
} as any);
const LvaRoute = LvaRouteImport.update({
  id: '/lva',
  path: '/lva',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const LedgerRoute = LedgerRouteImport.update({
  id: '/ledger',
  path: '/ledger',
  getParentRoute: () => rootRouteImport,
} as any);
const LeaseRoute = LeaseRouteImport.update({
  id: '/lease',
  path: '/lease',
  getParentRoute: () => rootRouteImport,
} as any);
const JournalRoute = JournalRouteImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => rootRouteImport,
} as any);
const GlschedRoute = GlschedRouteImport.update({
  id: '/glsched',
  path: '/glsched',
  getParentRoute: () => rootRouteImport,
} as any);
const FxrevalRoute = FxrevalRouteImport.update({
  id: '/fxreval',
  path: '/fxreval',
  getParentRoute: () => rootRouteImport,
} as any);
const FraudRoute = FraudRouteImport.update({
  id: '/fraud',
  path: '/fraud',
  getParentRoute: () => rootRouteImport,
} as any);
const FixedassetRoute = FixedassetRouteImport.update({
  id: '/fixedasset',
  path: '/fixedasset',
  getParentRoute: () => rootRouteImport,
} as any);
const EmpbenRoute = EmpbenRouteImport.update({
  id: '/empben',
  path: '/empben',
  getParentRoute: () => rootRouteImport,
} as any);
const DocIngestRoute = DocIngestRouteImport.update({
  id: '/doc-ingest',
  path: '/doc-ingest',
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any);
const ConsolRoute = ConsolRouteImport.update({
  id: '/consol',
  path: '/consol',
  getParentRoute: () => rootRouteImport,
} as any);
const CoaRoute = CoaRouteImport.update({
  id: '/coa',
  path: '/coa',
  getParentRoute: () => rootRouteImport,
} as any);
const CipRoute = CipRouteImport.update({
  id: '/cip',
  path: '/cip',
  getParentRoute: () => rootRouteImport,
} as any);
const CfforecastRoute = CfforecastRouteImport.update({
  id: '/cfforecast',
  path: '/cfforecast',
  getParentRoute: () => rootRouteImport,
} as any);
const AssetCategoriesRoute = AssetCategoriesRouteImport.update({
  id: '/asset-categories',
  path: '/asset-categories',
  getParentRoute: () => rootRouteImport,
} as any);
const ArRoute = ArRouteImport.update({
  id: '/ar',
  path: '/ar',
  getParentRoute: () => rootRouteImport,
} as any);
const ApRoute = ApRouteImport.update({
  id: '/ap',
  path: '/ap',
  getParentRoute: () => rootRouteImport,
} as any);
const AdvanceRoute = AdvanceRouteImport.update({
  id: '/advance',
  path: '/advance',
  getParentRoute: () => rootRouteImport,
} as any);
const AccrualRoute = AccrualRouteImport.update({
  id: '/accrual',
  path: '/accrual',
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsScanIntakeRoute = SettingsScanIntakeRouteImport.update({
  id: '/settings/scan-intake',
  path: '/settings/scan-intake',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsRolesRoute = SettingsRolesRouteImport.update({
  id: '/settings/roles',
  path: '/settings/roles',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsLineIntakeRoute = SettingsLineIntakeRouteImport.update({
  id: '/settings/line-intake',
  path: '/settings/line-intake',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsEmailIntakeRoute = SettingsEmailIntakeRouteImport.update({
  id: '/settings/email-intake',
  path: '/settings/email-intake',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsCoaRoute = SettingsCoaRouteImport.update({
  id: '/settings/coa',
  path: '/settings/coa',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsAuditRoute = SettingsAuditRouteImport.update({
  id: '/settings/audit',
  path: '/settings/audit',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsApprovalMatrixRoute = SettingsApprovalMatrixRouteImport.update({
  id: '/settings/approval-matrix',
  path: '/settings/approval-matrix',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsAccountMappingRoute = SettingsAccountMappingRouteImport.update({
  id: '/settings/account-mapping',
  path: '/settings/account-mapping',
  getParentRoute: () => rootRouteImport,
} as any);
const LvaCodeRoute = LvaCodeRouteImport.update({
  id: '/$code',
  path: '/$code',
  getParentRoute: () => LvaRoute,
} as any);
const DocIngestIdRoute = DocIngestIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DocIngestRoute,
} as any);
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any);
const ArVoidsRoute = ArVoidsRouteImport.update({
  id: '/voids',
  path: '/voids',
  getParentRoute: () => ArRoute,
} as any);
const ArReceiptsRoute = ArReceiptsRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => ArRoute,
} as any);
const ArPdcRoute = ArPdcRouteImport.update({
  id: '/pdc',
  path: '/pdc',
  getParentRoute: () => ArRoute,
} as any);
const ArDsoRoute = ArDsoRouteImport.update({
  id: '/dso',
  path: '/dso',
  getParentRoute: () => ArRoute,
} as any);
const ArCreditNotesRoute = ArCreditNotesRouteImport.update({
  id: '/credit-notes',
  path: '/credit-notes',
  getParentRoute: () => ArRoute,
} as any);
const ArBillingNotesRoute = ArBillingNotesRouteImport.update({
  id: '/billing-notes',
  path: '/billing-notes',
  getParentRoute: () => ArRoute,
} as any);
const ArAgingRoute = ArAgingRouteImport.update({
  id: '/aging',
  path: '/aging',
  getParentRoute: () => ArRoute,
} as any);
const ArAdvancesRoute = ArAdvancesRouteImport.update({
  id: '/advances',
  path: '/advances',
  getParentRoute: () => ArRoute,
} as any);
const AdvanceIdRoute = AdvanceIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AdvanceRoute,
} as any);
const LvaCountRoundIdRoute = LvaCountRoundIdRouteImport.update({
  id: '/count/$roundId',
  path: '/count/$roundId',
  getParentRoute: () => LvaRoute,
} as any);
const ArStatementCustomerIdRoute = ArStatementCustomerIdRouteImport.update({
  id: '/statement/$customerId',
  path: '/statement/$customerId',
  getParentRoute: () => ArRoute,
} as any);
const ArInvoicesIdRoute = ArInvoicesIdRouteImport.update({
  id: '/invoices/$id',
  path: '/invoices/$id',
  getParentRoute: () => ArRoute,
} as any);
const ApVendorVendorIdRoute = ApVendorVendorIdRouteImport.update({
  id: '/vendor/$vendorId',
  path: '/vendor/$vendorId',
  getParentRoute: () => ApRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/accrual': typeof AccrualRoute;
  '/advance': typeof AdvanceRouteWithChildren;
  '/ap': typeof ApRouteWithChildren;
  '/ar': typeof ArRouteWithChildren;
  '/asset-categories': typeof AssetCategoriesRoute;
  '/cfforecast': typeof CfforecastRoute;
  '/cip': typeof CipRoute;
  '/coa': typeof CoaRoute;
  '/consol': typeof ConsolRoute;
  '/dashboard': typeof DashboardRoute;
  '/doc-ingest': typeof DocIngestRouteWithChildren;
  '/empben': typeof EmpbenRoute;
  '/fixedasset': typeof FixedassetRoute;
  '/fraud': typeof FraudRoute;
  '/fxreval': typeof FxrevalRoute;
  '/glsched': typeof GlschedRoute;
  '/journal': typeof JournalRoute;
  '/lease': typeof LeaseRoute;
  '/ledger': typeof LedgerRoute;
  '/login': typeof LoginRoute;
  '/lva': typeof LvaRouteWithChildren;
  '/master': typeof MasterRoute;
  '/opcontract': typeof OpcontractRoute;
  '/payreq': typeof PayreqRoute;
  '/pclose': typeof PcloseRoute;
  '/pettycash': typeof PettycashRoute;
  '/ppemove': typeof PpemoveRoute;
  '/prepaid': typeof PrepaidRoute;
  '/proptax': typeof ProptaxRoute;
  '/reclass': typeof ReclassRoute;
  '/recon': typeof ReconRoute;
  '/reports': typeof ReportsRoute;
  '/suppliers': typeof SuppliersRoute;
  '/taxadj': typeof TaxadjRoute;
  '/taxrecon': typeof TaxreconRoute;
  '/vat': typeof VatRoute;
  '/wht': typeof WhtRoute;
  '/advance/$id': typeof AdvanceIdRoute;
  '/ar/advances': typeof ArAdvancesRoute;
  '/ar/aging': typeof ArAgingRoute;
  '/ar/billing-notes': typeof ArBillingNotesRoute;
  '/ar/credit-notes': typeof ArCreditNotesRoute;
  '/ar/dso': typeof ArDsoRoute;
  '/ar/pdc': typeof ArPdcRoute;
  '/ar/receipts': typeof ArReceiptsRoute;
  '/ar/voids': typeof ArVoidsRoute;
  '/auth/callback': typeof AuthCallbackRoute;
  '/doc-ingest/$id': typeof DocIngestIdRoute;
  '/lva/$code': typeof LvaCodeRoute;
  '/settings/account-mapping': typeof SettingsAccountMappingRoute;
  '/settings/approval-matrix': typeof SettingsApprovalMatrixRoute;
  '/settings/audit': typeof SettingsAuditRoute;
  '/settings/coa': typeof SettingsCoaRoute;
  '/settings/email-intake': typeof SettingsEmailIntakeRoute;
  '/settings/line-intake': typeof SettingsLineIntakeRoute;
  '/settings/roles': typeof SettingsRolesRoute;
  '/settings/scan-intake': typeof SettingsScanIntakeRoute;
  '/settings/users': typeof SettingsUsersRoute;
  '/ap/vendor/$vendorId': typeof ApVendorVendorIdRoute;
  '/ar/invoices/$id': typeof ArInvoicesIdRoute;
  '/ar/statement/$customerId': typeof ArStatementCustomerIdRoute;
  '/lva/count/$roundId': typeof LvaCountRoundIdRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/accrual': typeof AccrualRoute;
  '/advance': typeof AdvanceRouteWithChildren;
  '/ap': typeof ApRouteWithChildren;
  '/ar': typeof ArRouteWithChildren;
  '/asset-categories': typeof AssetCategoriesRoute;
  '/cfforecast': typeof CfforecastRoute;
  '/cip': typeof CipRoute;
  '/coa': typeof CoaRoute;
  '/consol': typeof ConsolRoute;
  '/dashboard': typeof DashboardRoute;
  '/doc-ingest': typeof DocIngestRouteWithChildren;
  '/empben': typeof EmpbenRoute;
  '/fixedasset': typeof FixedassetRoute;
  '/fraud': typeof FraudRoute;
  '/fxreval': typeof FxrevalRoute;
  '/glsched': typeof GlschedRoute;
  '/journal': typeof JournalRoute;
  '/lease': typeof LeaseRoute;
  '/ledger': typeof LedgerRoute;
  '/login': typeof LoginRoute;
  '/lva': typeof LvaRouteWithChildren;
  '/master': typeof MasterRoute;
  '/opcontract': typeof OpcontractRoute;
  '/payreq': typeof PayreqRoute;
  '/pclose': typeof PcloseRoute;
  '/pettycash': typeof PettycashRoute;
  '/ppemove': typeof PpemoveRoute;
  '/prepaid': typeof PrepaidRoute;
  '/proptax': typeof ProptaxRoute;
  '/reclass': typeof ReclassRoute;
  '/recon': typeof ReconRoute;
  '/reports': typeof ReportsRoute;
  '/suppliers': typeof SuppliersRoute;
  '/taxadj': typeof TaxadjRoute;
  '/taxrecon': typeof TaxreconRoute;
  '/vat': typeof VatRoute;
  '/wht': typeof WhtRoute;
  '/advance/$id': typeof AdvanceIdRoute;
  '/ar/advances': typeof ArAdvancesRoute;
  '/ar/aging': typeof ArAgingRoute;
  '/ar/billing-notes': typeof ArBillingNotesRoute;
  '/ar/credit-notes': typeof ArCreditNotesRoute;
  '/ar/dso': typeof ArDsoRoute;
  '/ar/pdc': typeof ArPdcRoute;
  '/ar/receipts': typeof ArReceiptsRoute;
  '/ar/voids': typeof ArVoidsRoute;
  '/auth/callback': typeof AuthCallbackRoute;
  '/doc-ingest/$id': typeof DocIngestIdRoute;
  '/lva/$code': typeof LvaCodeRoute;
  '/settings/account-mapping': typeof SettingsAccountMappingRoute;
  '/settings/approval-matrix': typeof SettingsApprovalMatrixRoute;
  '/settings/audit': typeof SettingsAuditRoute;
  '/settings/coa': typeof SettingsCoaRoute;
  '/settings/email-intake': typeof SettingsEmailIntakeRoute;
  '/settings/line-intake': typeof SettingsLineIntakeRoute;
  '/settings/roles': typeof SettingsRolesRoute;
  '/settings/scan-intake': typeof SettingsScanIntakeRoute;
  '/settings/users': typeof SettingsUsersRoute;
  '/ap/vendor/$vendorId': typeof ApVendorVendorIdRoute;
  '/ar/invoices/$id': typeof ArInvoicesIdRoute;
  '/ar/statement/$customerId': typeof ArStatementCustomerIdRoute;
  '/lva/count/$roundId': typeof LvaCountRoundIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/accrual': typeof AccrualRoute;
  '/advance': typeof AdvanceRouteWithChildren;
  '/ap': typeof ApRouteWithChildren;
  '/ar': typeof ArRouteWithChildren;
  '/asset-categories': typeof AssetCategoriesRoute;
  '/cfforecast': typeof CfforecastRoute;
  '/cip': typeof CipRoute;
  '/coa': typeof CoaRoute;
  '/consol': typeof ConsolRoute;
  '/dashboard': typeof DashboardRoute;
  '/doc-ingest': typeof DocIngestRouteWithChildren;
  '/empben': typeof EmpbenRoute;
  '/fixedasset': typeof FixedassetRoute;
  '/fraud': typeof FraudRoute;
  '/fxreval': typeof FxrevalRoute;
  '/glsched': typeof GlschedRoute;
  '/journal': typeof JournalRoute;
  '/lease': typeof LeaseRoute;
  '/ledger': typeof LedgerRoute;
  '/login': typeof LoginRoute;
  '/lva': typeof LvaRouteWithChildren;
  '/master': typeof MasterRoute;
  '/opcontract': typeof OpcontractRoute;
  '/payreq': typeof PayreqRoute;
  '/pclose': typeof PcloseRoute;
  '/pettycash': typeof PettycashRoute;
  '/ppemove': typeof PpemoveRoute;
  '/prepaid': typeof PrepaidRoute;
  '/proptax': typeof ProptaxRoute;
  '/reclass': typeof ReclassRoute;
  '/recon': typeof ReconRoute;
  '/reports': typeof ReportsRoute;
  '/suppliers': typeof SuppliersRoute;
  '/taxadj': typeof TaxadjRoute;
  '/taxrecon': typeof TaxreconRoute;
  '/vat': typeof VatRoute;
  '/wht': typeof WhtRoute;
  '/advance/$id': typeof AdvanceIdRoute;
  '/ar/advances': typeof ArAdvancesRoute;
  '/ar/aging': typeof ArAgingRoute;
  '/ar/billing-notes': typeof ArBillingNotesRoute;
  '/ar/credit-notes': typeof ArCreditNotesRoute;
  '/ar/dso': typeof ArDsoRoute;
  '/ar/pdc': typeof ArPdcRoute;
  '/ar/receipts': typeof ArReceiptsRoute;
  '/ar/voids': typeof ArVoidsRoute;
  '/auth/callback': typeof AuthCallbackRoute;
  '/doc-ingest/$id': typeof DocIngestIdRoute;
  '/lva/$code': typeof LvaCodeRoute;
  '/settings/account-mapping': typeof SettingsAccountMappingRoute;
  '/settings/approval-matrix': typeof SettingsApprovalMatrixRoute;
  '/settings/audit': typeof SettingsAuditRoute;
  '/settings/coa': typeof SettingsCoaRoute;
  '/settings/email-intake': typeof SettingsEmailIntakeRoute;
  '/settings/line-intake': typeof SettingsLineIntakeRoute;
  '/settings/roles': typeof SettingsRolesRoute;
  '/settings/scan-intake': typeof SettingsScanIntakeRoute;
  '/settings/users': typeof SettingsUsersRoute;
  '/ap/vendor/$vendorId': typeof ApVendorVendorIdRoute;
  '/ar/invoices/$id': typeof ArInvoicesIdRoute;
  '/ar/statement/$customerId': typeof ArStatementCustomerIdRoute;
  '/lva/count/$roundId': typeof LvaCountRoundIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/accrual'
    | '/advance'
    | '/ap'
    | '/ar'
    | '/asset-categories'
    | '/cfforecast'
    | '/cip'
    | '/coa'
    | '/consol'
    | '/dashboard'
    | '/doc-ingest'
    | '/empben'
    | '/fixedasset'
    | '/fraud'
    | '/fxreval'
    | '/glsched'
    | '/journal'
    | '/lease'
    | '/ledger'
    | '/login'
    | '/lva'
    | '/master'
    | '/opcontract'
    | '/payreq'
    | '/pclose'
    | '/pettycash'
    | '/ppemove'
    | '/prepaid'
    | '/proptax'
    | '/reclass'
    | '/recon'
    | '/reports'
    | '/suppliers'
    | '/taxadj'
    | '/taxrecon'
    | '/vat'
    | '/wht'
    | '/advance/$id'
    | '/ar/advances'
    | '/ar/aging'
    | '/ar/billing-notes'
    | '/ar/credit-notes'
    | '/ar/dso'
    | '/ar/pdc'
    | '/ar/receipts'
    | '/ar/voids'
    | '/auth/callback'
    | '/doc-ingest/$id'
    | '/lva/$code'
    | '/settings/account-mapping'
    | '/settings/approval-matrix'
    | '/settings/audit'
    | '/settings/coa'
    | '/settings/email-intake'
    | '/settings/line-intake'
    | '/settings/roles'
    | '/settings/scan-intake'
    | '/settings/users'
    | '/ap/vendor/$vendorId'
    | '/ar/invoices/$id'
    | '/ar/statement/$customerId'
    | '/lva/count/$roundId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/accrual'
    | '/advance'
    | '/ap'
    | '/ar'
    | '/asset-categories'
    | '/cfforecast'
    | '/cip'
    | '/coa'
    | '/consol'
    | '/dashboard'
    | '/doc-ingest'
    | '/empben'
    | '/fixedasset'
    | '/fraud'
    | '/fxreval'
    | '/glsched'
    | '/journal'
    | '/lease'
    | '/ledger'
    | '/login'
    | '/lva'
    | '/master'
    | '/opcontract'
    | '/payreq'
    | '/pclose'
    | '/pettycash'
    | '/ppemove'
    | '/prepaid'
    | '/proptax'
    | '/reclass'
    | '/recon'
    | '/reports'
    | '/suppliers'
    | '/taxadj'
    | '/taxrecon'
    | '/vat'
    | '/wht'
    | '/advance/$id'
    | '/ar/advances'
    | '/ar/aging'
    | '/ar/billing-notes'
    | '/ar/credit-notes'
    | '/ar/dso'
    | '/ar/pdc'
    | '/ar/receipts'
    | '/ar/voids'
    | '/auth/callback'
    | '/doc-ingest/$id'
    | '/lva/$code'
    | '/settings/account-mapping'
    | '/settings/approval-matrix'
    | '/settings/audit'
    | '/settings/coa'
    | '/settings/email-intake'
    | '/settings/line-intake'
    | '/settings/roles'
    | '/settings/scan-intake'
    | '/settings/users'
    | '/ap/vendor/$vendorId'
    | '/ar/invoices/$id'
    | '/ar/statement/$customerId'
    | '/lva/count/$roundId';
  id:
    | '__root__'
    | '/'
    | '/accrual'
    | '/advance'
    | '/ap'
    | '/ar'
    | '/asset-categories'
    | '/cfforecast'
    | '/cip'
    | '/coa'
    | '/consol'
    | '/dashboard'
    | '/doc-ingest'
    | '/empben'
    | '/fixedasset'
    | '/fraud'
    | '/fxreval'
    | '/glsched'
    | '/journal'
    | '/lease'
    | '/ledger'
    | '/login'
    | '/lva'
    | '/master'
    | '/opcontract'
    | '/payreq'
    | '/pclose'
    | '/pettycash'
    | '/ppemove'
    | '/prepaid'
    | '/proptax'
    | '/reclass'
    | '/recon'
    | '/reports'
    | '/suppliers'
    | '/taxadj'
    | '/taxrecon'
    | '/vat'
    | '/wht'
    | '/advance/$id'
    | '/ar/advances'
    | '/ar/aging'
    | '/ar/billing-notes'
    | '/ar/credit-notes'
    | '/ar/dso'
    | '/ar/pdc'
    | '/ar/receipts'
    | '/ar/voids'
    | '/auth/callback'
    | '/doc-ingest/$id'
    | '/lva/$code'
    | '/settings/account-mapping'
    | '/settings/approval-matrix'
    | '/settings/audit'
    | '/settings/coa'
    | '/settings/email-intake'
    | '/settings/line-intake'
    | '/settings/roles'
    | '/settings/scan-intake'
    | '/settings/users'
    | '/ap/vendor/$vendorId'
    | '/ar/invoices/$id'
    | '/ar/statement/$customerId'
    | '/lva/count/$roundId';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AccrualRoute: typeof AccrualRoute;
  AdvanceRoute: typeof AdvanceRouteWithChildren;
  ApRoute: typeof ApRouteWithChildren;
  ArRoute: typeof ArRouteWithChildren;
  AssetCategoriesRoute: typeof AssetCategoriesRoute;
  CfforecastRoute: typeof CfforecastRoute;
  CipRoute: typeof CipRoute;
  CoaRoute: typeof CoaRoute;
  ConsolRoute: typeof ConsolRoute;
  DashboardRoute: typeof DashboardRoute;
  DocIngestRoute: typeof DocIngestRouteWithChildren;
  EmpbenRoute: typeof EmpbenRoute;
  FixedassetRoute: typeof FixedassetRoute;
  FraudRoute: typeof FraudRoute;
  FxrevalRoute: typeof FxrevalRoute;
  GlschedRoute: typeof GlschedRoute;
  JournalRoute: typeof JournalRoute;
  LeaseRoute: typeof LeaseRoute;
  LedgerRoute: typeof LedgerRoute;
  LoginRoute: typeof LoginRoute;
  LvaRoute: typeof LvaRouteWithChildren;
  MasterRoute: typeof MasterRoute;
  OpcontractRoute: typeof OpcontractRoute;
  PayreqRoute: typeof PayreqRoute;
  PcloseRoute: typeof PcloseRoute;
  PettycashRoute: typeof PettycashRoute;
  PpemoveRoute: typeof PpemoveRoute;
  PrepaidRoute: typeof PrepaidRoute;
  ProptaxRoute: typeof ProptaxRoute;
  ReclassRoute: typeof ReclassRoute;
  ReconRoute: typeof ReconRoute;
  ReportsRoute: typeof ReportsRoute;
  SuppliersRoute: typeof SuppliersRoute;
  TaxadjRoute: typeof TaxadjRoute;
  TaxreconRoute: typeof TaxreconRoute;
  VatRoute: typeof VatRoute;
  WhtRoute: typeof WhtRoute;
  AuthCallbackRoute: typeof AuthCallbackRoute;
  SettingsAccountMappingRoute: typeof SettingsAccountMappingRoute;
  SettingsApprovalMatrixRoute: typeof SettingsApprovalMatrixRoute;
  SettingsAuditRoute: typeof SettingsAuditRoute;
  SettingsCoaRoute: typeof SettingsCoaRoute;
  SettingsEmailIntakeRoute: typeof SettingsEmailIntakeRoute;
  SettingsLineIntakeRoute: typeof SettingsLineIntakeRoute;
  SettingsRolesRoute: typeof SettingsRolesRoute;
  SettingsScanIntakeRoute: typeof SettingsScanIntakeRoute;
  SettingsUsersRoute: typeof SettingsUsersRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wht': {
      id: '/wht';
      path: '/wht';
      fullPath: '/wht';
      preLoaderRoute: typeof WhtRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/vat': {
      id: '/vat';
      path: '/vat';
      fullPath: '/vat';
      preLoaderRoute: typeof VatRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/taxrecon': {
      id: '/taxrecon';
      path: '/taxrecon';
      fullPath: '/taxrecon';
      preLoaderRoute: typeof TaxreconRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/taxadj': {
      id: '/taxadj';
      path: '/taxadj';
      fullPath: '/taxadj';
      preLoaderRoute: typeof TaxadjRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/suppliers': {
      id: '/suppliers';
      path: '/suppliers';
      fullPath: '/suppliers';
      preLoaderRoute: typeof SuppliersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reports': {
      id: '/reports';
      path: '/reports';
      fullPath: '/reports';
      preLoaderRoute: typeof ReportsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/recon': {
      id: '/recon';
      path: '/recon';
      fullPath: '/recon';
      preLoaderRoute: typeof ReconRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reclass': {
      id: '/reclass';
      path: '/reclass';
      fullPath: '/reclass';
      preLoaderRoute: typeof ReclassRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/proptax': {
      id: '/proptax';
      path: '/proptax';
      fullPath: '/proptax';
      preLoaderRoute: typeof ProptaxRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/prepaid': {
      id: '/prepaid';
      path: '/prepaid';
      fullPath: '/prepaid';
      preLoaderRoute: typeof PrepaidRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ppemove': {
      id: '/ppemove';
      path: '/ppemove';
      fullPath: '/ppemove';
      preLoaderRoute: typeof PpemoveRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pettycash': {
      id: '/pettycash';
      path: '/pettycash';
      fullPath: '/pettycash';
      preLoaderRoute: typeof PettycashRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pclose': {
      id: '/pclose';
      path: '/pclose';
      fullPath: '/pclose';
      preLoaderRoute: typeof PcloseRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/payreq': {
      id: '/payreq';
      path: '/payreq';
      fullPath: '/payreq';
      preLoaderRoute: typeof PayreqRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/opcontract': {
      id: '/opcontract';
      path: '/opcontract';
      fullPath: '/opcontract';
      preLoaderRoute: typeof OpcontractRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/master': {
      id: '/master';
      path: '/master';
      fullPath: '/master';
      preLoaderRoute: typeof MasterRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/lva': {
      id: '/lva';
      path: '/lva';
      fullPath: '/lva';
      preLoaderRoute: typeof LvaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ledger': {
      id: '/ledger';
      path: '/ledger';
      fullPath: '/ledger';
      preLoaderRoute: typeof LedgerRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/lease': {
      id: '/lease';
      path: '/lease';
      fullPath: '/lease';
      preLoaderRoute: typeof LeaseRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/journal': {
      id: '/journal';
      path: '/journal';
      fullPath: '/journal';
      preLoaderRoute: typeof JournalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/glsched': {
      id: '/glsched';
      path: '/glsched';
      fullPath: '/glsched';
      preLoaderRoute: typeof GlschedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/fxreval': {
      id: '/fxreval';
      path: '/fxreval';
      fullPath: '/fxreval';
      preLoaderRoute: typeof FxrevalRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/fraud': {
      id: '/fraud';
      path: '/fraud';
      fullPath: '/fraud';
      preLoaderRoute: typeof FraudRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/fixedasset': {
      id: '/fixedasset';
      path: '/fixedasset';
      fullPath: '/fixedasset';
      preLoaderRoute: typeof FixedassetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/empben': {
      id: '/empben';
      path: '/empben';
      fullPath: '/empben';
      preLoaderRoute: typeof EmpbenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/doc-ingest': {
      id: '/doc-ingest';
      path: '/doc-ingest';
      fullPath: '/doc-ingest';
      preLoaderRoute: typeof DocIngestRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/dashboard': {
      id: '/dashboard';
      path: '/dashboard';
      fullPath: '/dashboard';
      preLoaderRoute: typeof DashboardRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/consol': {
      id: '/consol';
      path: '/consol';
      fullPath: '/consol';
      preLoaderRoute: typeof ConsolRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/coa': {
      id: '/coa';
      path: '/coa';
      fullPath: '/coa';
      preLoaderRoute: typeof CoaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cip': {
      id: '/cip';
      path: '/cip';
      fullPath: '/cip';
      preLoaderRoute: typeof CipRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/cfforecast': {
      id: '/cfforecast';
      path: '/cfforecast';
      fullPath: '/cfforecast';
      preLoaderRoute: typeof CfforecastRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/asset-categories': {
      id: '/asset-categories';
      path: '/asset-categories';
      fullPath: '/asset-categories';
      preLoaderRoute: typeof AssetCategoriesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ar': {
      id: '/ar';
      path: '/ar';
      fullPath: '/ar';
      preLoaderRoute: typeof ArRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ap': {
      id: '/ap';
      path: '/ap';
      fullPath: '/ap';
      preLoaderRoute: typeof ApRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/advance': {
      id: '/advance';
      path: '/advance';
      fullPath: '/advance';
      preLoaderRoute: typeof AdvanceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/accrual': {
      id: '/accrual';
      path: '/accrual';
      fullPath: '/accrual';
      preLoaderRoute: typeof AccrualRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/users': {
      id: '/settings/users';
      path: '/settings/users';
      fullPath: '/settings/users';
      preLoaderRoute: typeof SettingsUsersRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/scan-intake': {
      id: '/settings/scan-intake';
      path: '/settings/scan-intake';
      fullPath: '/settings/scan-intake';
      preLoaderRoute: typeof SettingsScanIntakeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/roles': {
      id: '/settings/roles';
      path: '/settings/roles';
      fullPath: '/settings/roles';
      preLoaderRoute: typeof SettingsRolesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/line-intake': {
      id: '/settings/line-intake';
      path: '/settings/line-intake';
      fullPath: '/settings/line-intake';
      preLoaderRoute: typeof SettingsLineIntakeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/email-intake': {
      id: '/settings/email-intake';
      path: '/settings/email-intake';
      fullPath: '/settings/email-intake';
      preLoaderRoute: typeof SettingsEmailIntakeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/coa': {
      id: '/settings/coa';
      path: '/settings/coa';
      fullPath: '/settings/coa';
      preLoaderRoute: typeof SettingsCoaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/audit': {
      id: '/settings/audit';
      path: '/settings/audit';
      fullPath: '/settings/audit';
      preLoaderRoute: typeof SettingsAuditRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/approval-matrix': {
      id: '/settings/approval-matrix';
      path: '/settings/approval-matrix';
      fullPath: '/settings/approval-matrix';
      preLoaderRoute: typeof SettingsApprovalMatrixRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/account-mapping': {
      id: '/settings/account-mapping';
      path: '/settings/account-mapping';
      fullPath: '/settings/account-mapping';
      preLoaderRoute: typeof SettingsAccountMappingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/lva/$code': {
      id: '/lva/$code';
      path: '/$code';
      fullPath: '/lva/$code';
      preLoaderRoute: typeof LvaCodeRouteImport;
      parentRoute: typeof LvaRoute;
    };
    '/doc-ingest/$id': {
      id: '/doc-ingest/$id';
      path: '/$id';
      fullPath: '/doc-ingest/$id';
      preLoaderRoute: typeof DocIngestIdRouteImport;
      parentRoute: typeof DocIngestRoute;
    };
    '/auth/callback': {
      id: '/auth/callback';
      path: '/auth/callback';
      fullPath: '/auth/callback';
      preLoaderRoute: typeof AuthCallbackRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/ar/voids': {
      id: '/ar/voids';
      path: '/voids';
      fullPath: '/ar/voids';
      preLoaderRoute: typeof ArVoidsRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ar/receipts': {
      id: '/ar/receipts';
      path: '/receipts';
      fullPath: '/ar/receipts';
      preLoaderRoute: typeof ArReceiptsRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ar/pdc': {
      id: '/ar/pdc';
      path: '/pdc';
      fullPath: '/ar/pdc';
      preLoaderRoute: typeof ArPdcRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ar/dso': {
      id: '/ar/dso';
      path: '/dso';
      fullPath: '/ar/dso';
      preLoaderRoute: typeof ArDsoRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ar/credit-notes': {
      id: '/ar/credit-notes';
      path: '/credit-notes';
      fullPath: '/ar/credit-notes';
      preLoaderRoute: typeof ArCreditNotesRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ar/billing-notes': {
      id: '/ar/billing-notes';
      path: '/billing-notes';
      fullPath: '/ar/billing-notes';
      preLoaderRoute: typeof ArBillingNotesRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ar/aging': {
      id: '/ar/aging';
      path: '/aging';
      fullPath: '/ar/aging';
      preLoaderRoute: typeof ArAgingRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ar/advances': {
      id: '/ar/advances';
      path: '/advances';
      fullPath: '/ar/advances';
      preLoaderRoute: typeof ArAdvancesRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/advance/$id': {
      id: '/advance/$id';
      path: '/$id';
      fullPath: '/advance/$id';
      preLoaderRoute: typeof AdvanceIdRouteImport;
      parentRoute: typeof AdvanceRoute;
    };
    '/lva/count/$roundId': {
      id: '/lva/count/$roundId';
      path: '/count/$roundId';
      fullPath: '/lva/count/$roundId';
      preLoaderRoute: typeof LvaCountRoundIdRouteImport;
      parentRoute: typeof LvaRoute;
    };
    '/ar/statement/$customerId': {
      id: '/ar/statement/$customerId';
      path: '/statement/$customerId';
      fullPath: '/ar/statement/$customerId';
      preLoaderRoute: typeof ArStatementCustomerIdRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ar/invoices/$id': {
      id: '/ar/invoices/$id';
      path: '/invoices/$id';
      fullPath: '/ar/invoices/$id';
      preLoaderRoute: typeof ArInvoicesIdRouteImport;
      parentRoute: typeof ArRoute;
    };
    '/ap/vendor/$vendorId': {
      id: '/ap/vendor/$vendorId';
      path: '/vendor/$vendorId';
      fullPath: '/ap/vendor/$vendorId';
      preLoaderRoute: typeof ApVendorVendorIdRouteImport;
      parentRoute: typeof ApRoute;
    };
  }
}

interface AdvanceRouteChildren {
  AdvanceIdRoute: typeof AdvanceIdRoute;
}

const AdvanceRouteChildren: AdvanceRouteChildren = {
  AdvanceIdRoute: AdvanceIdRoute,
};

const AdvanceRouteWithChildren =
  AdvanceRoute._addFileChildren(AdvanceRouteChildren);

interface ApRouteChildren {
  ApVendorVendorIdRoute: typeof ApVendorVendorIdRoute;
}

const ApRouteChildren: ApRouteChildren = {
  ApVendorVendorIdRoute: ApVendorVendorIdRoute,
};

const ApRouteWithChildren = ApRoute._addFileChildren(ApRouteChildren);

interface ArRouteChildren {
  ArAdvancesRoute: typeof ArAdvancesRoute;
  ArAgingRoute: typeof ArAgingRoute;
  ArBillingNotesRoute: typeof ArBillingNotesRoute;
  ArCreditNotesRoute: typeof ArCreditNotesRoute;
  ArDsoRoute: typeof ArDsoRoute;
  ArPdcRoute: typeof ArPdcRoute;
  ArReceiptsRoute: typeof ArReceiptsRoute;
  ArVoidsRoute: typeof ArVoidsRoute;
  ArInvoicesIdRoute: typeof ArInvoicesIdRoute;
  ArStatementCustomerIdRoute: typeof ArStatementCustomerIdRoute;
}

const ArRouteChildren: ArRouteChildren = {
  ArAdvancesRoute: ArAdvancesRoute,
  ArAgingRoute: ArAgingRoute,
  ArBillingNotesRoute: ArBillingNotesRoute,
  ArCreditNotesRoute: ArCreditNotesRoute,
  ArDsoRoute: ArDsoRoute,
  ArPdcRoute: ArPdcRoute,
  ArReceiptsRoute: ArReceiptsRoute,
  ArVoidsRoute: ArVoidsRoute,
  ArInvoicesIdRoute: ArInvoicesIdRoute,
  ArStatementCustomerIdRoute: ArStatementCustomerIdRoute,
};

const ArRouteWithChildren = ArRoute._addFileChildren(ArRouteChildren);

interface DocIngestRouteChildren {
  DocIngestIdRoute: typeof DocIngestIdRoute;
}

const DocIngestRouteChildren: DocIngestRouteChildren = {
  DocIngestIdRoute: DocIngestIdRoute,
};

const DocIngestRouteWithChildren = DocIngestRoute._addFileChildren(
  DocIngestRouteChildren,
);

interface LvaRouteChildren {
  LvaCodeRoute: typeof LvaCodeRoute;
  LvaCountRoundIdRoute: typeof LvaCountRoundIdRoute;
}

const LvaRouteChildren: LvaRouteChildren = {
  LvaCodeRoute: LvaCodeRoute,
  LvaCountRoundIdRoute: LvaCountRoundIdRoute,
};

const LvaRouteWithChildren = LvaRoute._addFileChildren(LvaRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccrualRoute: AccrualRoute,
  AdvanceRoute: AdvanceRouteWithChildren,
  ApRoute: ApRouteWithChildren,
  ArRoute: ArRouteWithChildren,
  AssetCategoriesRoute: AssetCategoriesRoute,
  CfforecastRoute: CfforecastRoute,
  CipRoute: CipRoute,
  CoaRoute: CoaRoute,
  ConsolRoute: ConsolRoute,
  DashboardRoute: DashboardRoute,
  DocIngestRoute: DocIngestRouteWithChildren,
  EmpbenRoute: EmpbenRoute,
  FixedassetRoute: FixedassetRoute,
  FraudRoute: FraudRoute,
  FxrevalRoute: FxrevalRoute,
  GlschedRoute: GlschedRoute,
  JournalRoute: JournalRoute,
  LeaseRoute: LeaseRoute,
  LedgerRoute: LedgerRoute,
  LoginRoute: LoginRoute,
  LvaRoute: LvaRouteWithChildren,
  MasterRoute: MasterRoute,
  OpcontractRoute: OpcontractRoute,
  PayreqRoute: PayreqRoute,
  PcloseRoute: PcloseRoute,
  PettycashRoute: PettycashRoute,
  PpemoveRoute: PpemoveRoute,
  PrepaidRoute: PrepaidRoute,
  ProptaxRoute: ProptaxRoute,
  ReclassRoute: ReclassRoute,
  ReconRoute: ReconRoute,
  ReportsRoute: ReportsRoute,
  SuppliersRoute: SuppliersRoute,
  TaxadjRoute: TaxadjRoute,
  TaxreconRoute: TaxreconRoute,
  VatRoute: VatRoute,
  WhtRoute: WhtRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  SettingsAccountMappingRoute: SettingsAccountMappingRoute,
  SettingsApprovalMatrixRoute: SettingsApprovalMatrixRoute,
  SettingsAuditRoute: SettingsAuditRoute,
  SettingsCoaRoute: SettingsCoaRoute,
  SettingsEmailIntakeRoute: SettingsEmailIntakeRoute,
  SettingsLineIntakeRoute: SettingsLineIntakeRoute,
  SettingsRolesRoute: SettingsRolesRoute,
  SettingsScanIntakeRoute: SettingsScanIntakeRoute,
  SettingsUsersRoute: SettingsUsersRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
